import { Stack, Grid } from '../../../base';
import { useTranslation } from 'react-i18next';
import { StyledTitle } from './SocialMediaTab.styles';
import SocialMediaCard from './SocialMediaCard';
import { SocialMediaConnections, SocialMediaPlatforms } from '../../../common';

const SocialMediaTab = () => {
    const { t } = useTranslation();

    const isConnected = (name: SocialMediaPlatforms) => {
        return false;
    };

    return (
        <Stack spacing={2} paddingInlineEnd={2}>
            <StyledTitle variant="body2">
                {t('settings.socialMedia.title')}
            </StyledTitle>
            <Grid container spacing={3}>
                {SocialMediaConnections.map((platform) => (
                    <Grid item xs={12} sm={6} lg={4} xl={3} key={platform.name}>
                        <SocialMediaCard
                            name={platform.name}
                            avatar={platform.avatar}
                            isConnected={isConnected(platform.name)}
                        />
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default SocialMediaTab;
